import React, { useContext } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import SVG from 'react-inlinesvg';

import useAuth from '../../context/AuthContext';
import { getAdminMenu } from '../../helpers/localData';
import NotificationCenter from '../../components/NotificationCenter';

const AdminSideBarMenu = () => {
  const { isTenant } = useAuth();
  const { pathname } = useLocation();

  return (
    <div
      style={{
        padding: '0px 16px 16px 5vw',
        gap: '16px',
        height: 'calc(100dvh - 99px)',
        minWidth: '318px',
        overflowY: 'auto'
      }}
      className="flex flex-col bg-faint-charcoal border-r border-gray "
    >
      <h2
        className="pb-4 pt-12"
        style={{ fontSize: '24px', fontWeight: '700' }}
      >
        Admin
      </h2>
      {getAdminMenu(isTenant).map((item) => {
        const { route, text, icon, disabled } = item;
        return (
          !disabled && (
            <Link
              key={`link-${route}`}
              className={` font-bold py-2 px-4 -ml-4 rounded flex items-center ${
                pathname.includes(route)
                  ? 'bg-purple-100 text-link-purple'
                  : 'bg-white text-charcoal hover:bg-purple-100'
              }`}
              to={route}
              style={{ borderRadius: '12px' }}
            >
              <SVG
                src={icon}
                className={`mr-2 ${
                  pathname === route && 'admin-sidebar-menu-svg--active'
                }`}
              />
              {text}
            </Link>
          )
        );
      })}
    </div>
  );
};

export default function Admin() {
  const { userData, isEmployee } = useAuth();
  const isAdmin = userData?.roles?.includes('admin');
  const hasAccess = isAdmin || isEmployee;

  const navigate = useNavigate();

  if (!hasAccess) {
    navigate('/v2');
  }

  return (
    <div className="flex relative" style={{ flexGrow: 1, height: "calc(100dvh - 99px)", overflow: "clip" }}>
      {hasAccess && <AdminSideBarMenu />}
      <div
        style={{
          padding: '8px',
          flexGrow: 1,
          overflow: 'auto'
        }}
        className="admin-user"
      >
        <Outlet />
      </div>
      
      {hasAccess && <NotificationCenter /> }
    </div>
  );
}
